import React, { Component } from 'react';
import DefaultOption from 'react-select/lib/Option';
import _ from 'lodash';
import ReactSelect from 'react-select';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

const payerRenderer = payerNames => {
  if (payerNames.length >= 20) {
    return (
      <div>{`    - also known by ${payerNames.length} other names including ${payerNames
        .slice(0, 3)
        .join('; ')}`}</div>
    );
  } else if (payerNames.length >= 1) {
    return <div>{`    - also known as ${payerNames.join('; ')}`}</div>;
  }
  return null;
};

// NB: This can't be a stateless functional component, because it's given a ref
class PayerGroupOption extends Component {
  // eslint-disable-line
  render() {
    return (
      <DefaultOption {...this.props}>
        <div>{this.props.option.text}</div>
        <i style={{ fontSize: 10 }}>{payerRenderer(this.props.option.payerNames)}</i>
      </DefaultOption>
    );
  }
}

const filter = (payerGroup, search) => {
  search = search.toLowerCase();
  return _.some(payerGroup.payerNames, name => name.toLowerCase().indexOf(search) >= 0);
};

const PayerGroupSelect = ({ onBlur, ...rest }) => {
  return (
    <ReactSelect
      {...rest}
      simpleValue
      optionComponent={PayerGroupOption}
      filterOption={filter}
      labelKey="text"
    />
  );
};

PayerGroupSelect.displayName = 'PayerGroupSelect';

export default PayerGroupSelect;

const PayerGroupSelectInput = connectFormComponentToReduxForm(PayerGroupSelect);

export { PayerGroupSelectInput };
